import {dispatch} from 'od-modules/secure_store/store';
import {
    SET_SHOPPING_CART,
    TOGGLE_RESIDENT_DISCOUNT,
    SET_RESIDENT_DISCOUNT,
} from 'od-modules/secure_store/actions';
import logger from 'od-modules/utils/logger';

let url = '';

export default {
    setDPUrl(dynpackCartProductId) {
        url = Odigeo.Settings.getProperty('dynpackUrlFormatter')(`shopping-cart/${dynpackCartProductId}/confirm`);
    },
    setMetaUrl() {
        url = Odigeo.Settings.getProperty('serviceUrlFormatter')('createshoppingcartresidentmeta');
    },
    getUrl() {
        return url || Odigeo.Settings.getProperty('serviceUrlFormatter')('createshoppingcart');
    },
    getMethod() {
        return 'POST';
    },
    requestSuccess(response) {
        const errors = response && response.errors || [];
        if (response && errors.length === 0) {
            dispatch({type: TOGGLE_RESIDENT_DISCOUNT});
            dispatch({type: SET_SHOPPING_CART, entry: response});
        }
        return response;
    },

    requestError(response) {
        dispatch({type: SET_RESIDENT_DISCOUNT, entry: false});
        logger.error(response, 'CreateShoppingCart call failed');
        return response;
    },
};
